"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./components/Callout/index'));

//# sourceMappingURL=Callout.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./Callout.js
 ** module id = 28
 ** module chunks = 0
 **/